/** @format */

export const datepickerConstantModule = 'sis-common.datepicker';

('use strict');
angular.module(datepickerConstantModule, []).constant('sisDatepickerConfig', {
    format: 'dd.MM.yyyy',
    altInputFormats: ['d!.M!.yyyy', 'yyyy-M!-d!'],
    defaultOptions: {
        startingDay: 1,
    },
});
